module.exports = __webpack_public_path__ + "img/loading.30757cd3.png";